import { Patient } from '../../entities/Patient';
import { api } from '../api';

export const updatePatient = async (patientData: Patient): Promise<Patient> => {
  const { data } = await api.put('/patients', { patientData });

  return data;
};
